import type { ColumnDef } from '@tanstack/react-table';

import type { GetMessagesSetsPaginatedQuery } from 'data/__generated__';
import { textColumn, dateColumn, numberColumn } from 'components/DataTable';

import { CommonStatusTag } from 'components/CommonStatusTag';
import { colors } from 'constants/colors';

export type MessagesSetRow = GetMessagesSetsPaginatedQuery['messagesSetsPaginated']['messagesSets'][number];

export const messagesSetsColumns: ColumnDef<MessagesSetRow, unknown>[] = [
    textColumn<MessagesSetRow, Record<string, unknown>>({
        accessorKey: 'name',
        header: 'Nom de la série',
        filterKey: 'name',
        defaultVisible: true,
    }),
    dateColumn<MessagesSetRow, Record<string, unknown>>({
        accessorKey: 'createdAt',
        header: 'Date de création',
        filterKey: 'createdAt',
        defaultVisible: true,
    }),
    numberColumn<MessagesSetRow, Record<string, unknown>>({
        id: 'messagesCount',
        accessorFn: (row) => row.messages.length,
        header: 'Nombre de messages',
        filterKey: 'messagesCount',
        defaultVisible: true,
    }),
    textColumn<MessagesSetRow, Record<string, unknown>>({
        accessorKey: 'state',
        header: 'Statut',
        filterKey: 'state',
        defaultVisible: true,
        cell: ({ row }) => (
            <CommonStatusTag label={row.original.state} backgroundColor={colors.green} labelColor={colors.black} />
        ),
    }),
];
